<template slot="items">
  <tr>
    <td class="text-sm-left">
      <v-autocomplete
        no-data-text="Datos no disponibles"
        :filter="customFilter"
        :items="productCatalog"
        item-text="name"
        return-object
        v-model="form.product"
      ></v-autocomplete>
    </td>
    <td class="text-sm-left">
      <v-select
        no-data-text="Datos no disponibles"
        :items="batchCatalog"
        clearable
        item-text="name"
        return-object
        v-model="form.batch"
      ></v-select>
    </td>
    <td class="text-sm-left">
      <v-select
        no-data-text="Datos no disponibles"
        :items="sanitaryRegCatalog"
        clearable
        item-text="name"
        return-object
        v-model="form.sanitaryReg"
      ></v-select>
    </td>
    <!-- <td class="text-sm-left">
      {{ form.batch ? form.batch.sanitaryReg : '--' }}
    </td> -->
    <td class="text-sm-left">
      {{ form.batch ? form.batch.fxFormula : '--' }}
    </td>
    <td class="text-sm-left">
      {{ form.batch ? dateFormat(form.batch.expirationDate) : '--' }}
    </td>
    <td class="text-sm-left">
      {{ form.batch ? form.batch.totalCertificate : '--' }}
    </td>
    <td class="text-sm-left">
      <v-chip
        :color="getColorByStatus(form.batch.batchStatus)"
        label
        small
        text-color="white"
        v-if="form.batch"
        >{{ getLabelByStatus(form.batch.batchStatus) }}</v-chip
      >
      <div v-else>--</div>
    </td>
    <td class="text-sm-left">
      <v-btn @click="removeRow" flat icon color="info">
        <v-icon>delete</v-icon>
      </v-btn>
    </td>
  </tr>
</template>

<script>
import {
  getColorByStatus,
  getLabelByStatus,
  dateFormat,
} from '@/helpers/TransitHelper'
import { mapGetters } from 'vuex'
export default {
  props: {
    row: {
      type: Object,
      required: true,
    },
    productCatalog: {
      type: Array,
      required: true,
    },
    index: Number,
  },
  data() {
    return {
      initital: true,
      form: {
        product: null,
        batch: null,
        sanitaryReg: null,
      },
      batchCatalog: [],
      sanitaryRegCatalog: [],
    }
  },
  computed: {
    ...mapGetters({
      InvoiceProducts: 'invoices/emptyItems',
    }),
  },
  created() {
    this.form.product = this.row.product ? this.row.product : null
    this.form.batch = this.row.batch ? this.row.batch : null
    this.form.sanitaryReg = this.row.sanitaryReg ? this.row.sanitaryReg : null
  },
  watch: {
    'form.product': function() {
      if (this.initital) {
        this.loadbatchCatalog()
        this.initital = false
      } else {
        this.loadbatchCatalog()
        this.row.product = this.form.product
        this.form.batch = null
        this.form.sanitaryReg = null
      }
    },
    'form.batch': function(val) {
      this.form.batch = val
      this.row.batch = val
      if (typeof val !== 'undefined') {
        this.sanitaryRegCatalog.forEach(element => {
          if (element.name === val.sanitaryReg) {
            this.form.sanitaryReg = element
          }
        })
      } else if (typeof val === 'undefined') {
        this.form.sanitaryReg = null
      }
    },
    'form.sanitaryReg': function(val) {
      this.form.sanitaryReg = val
      this.row.sanitaryReg = val
      if (
        typeof val !== 'undefined' &&
        (typeof this.form.batch === 'undefined' || this.form.batch === null)
      ) {
        this.batchCatalog.forEach(element => {
          if (element.sanitaryReg === val.name) {
            this.form.batch = element
          }
        })
      }
    },
  },
  methods: {
    dateFormat,
    getColorByStatus,
    getLabelByStatus,
    customFilter(item, queryText) {
      const itemName = item.name.toLowerCase()
      const searchText = queryText.toLowerCase()
      return itemName.startsWith(searchText)
    },
    removeRow() {
      this.InvoiceProducts.splice(this.index, 1)
    },
    loadbatchCatalog() {
      this.batchCatalog = []
      this.$store
        .dispatch('products/getAll', {
          productId: this.form.product.id,
        })
        .then(response => {
          const data = response.items
          for (let index in data) {
            this.batchCatalog.push({
              name: data[index].batchNumber,
              id: data[index].id,
              batchId: data[index].id,
              expirationDate: data[index].expirationDate,
              fxFormula: data[index].fxFormula,
              sanitaryReg: data[index].sanitaryReg,
              certificate: data[index].certificate,
              batchStatus: data[index].batchStatus,
              totalCertificate: data[index].total_certificate,
            })
            this.sanitaryRegCatalog.push({
              name: data[index].sanitaryReg,
              id: data[index].id,
            })
          }
        })
    },
  },
}
</script>
